// Phase A flip: /settings redirects to the new parent settings at
// /parent/settings. Legacy SettingsScreen.jsx goes dormant (deleted
// in Phase B).
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/settings")({
  beforeLoad: () => {
    throw redirect({ to: "/parent/settings" });
  },
  component: () => null,
});
